import { FixServerObject } from 'utils/types';

const API_ENDPOINT = 'WhatsAppContents';

export const API_WHATSAPP_CONTENTS = {
  API_ENDPOINT,
  GET_ALL_DYNAMIC: `${API_ENDPOINT}/GetAllDynamic`,
  POST: `${API_ENDPOINT}/Create`,
  SEND: `${API_ENDPOINT}/Send`,
  PATCH: (data: Pick<WhatsAppContents, 'id'>) => `${API_ENDPOINT}/Patch/${data.id}`,
  DELETE: (data: Pick<WhatsAppContents, 'id'>) => `${API_ENDPOINT}/Delete/${data.id}`,
};

export interface WhatsAppContents extends FixServerObject<Components.Schemas.WhatsAppContent, 'id'> {
}
export interface WhatsAppContentsCreateUpdateInput extends WhatsAppContents {
  userEmployeeProfilePermissionIDs: string[];
}
export interface WhatsAppContentsTestSendInput {
  id: string;
  phoneNumber: string;
}

export interface GetWhatsAppContentByKeyInput {
  languageID: string;
  contentKey: WHATSAPP_TEMPLATE_KEYS;
}

export enum WHATSAPP_TEMPLATE_KEYS {
  LEAD_ACTION_NO_ANSWER = '82b0bafc-d7a5-4b48-9667-678a98c4c7d3',
  LEAD_ACTION_CALL_LATER = '536c7fcb-95c5-4dff-992a-a5ef956dd528',
  LEAD_ACTION_ON_HOLD = '536c7fcb-95c5-4dff-992a-a5ef956dd528',
  LEAD_ACTION_NOT_RELEVANT = '536c7fcb-95c5-4dff-992a-a5ef956dd528',
  LEAD_ACTION_BACK_TO_US = '49079adb-193e-40d4-aa37-80afaad1b4fe',
}
